import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import ResolvePopup from 'components/ResolvePopup';
import { Button } from 'ncoded-component-library';
import DownloadIcon from 'icons/Download.icon';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import { useTranslation } from 'react-i18next';
import FileDownloadContext from 'providers/FileDownload/FileDownload.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { getCanDownloadNode } from 'utils';
import DataRoomSelectedDocumentsContext from '../../providers/DataRoomSelectedDocuments/DataRoomSelectedDocuments.context';

import './DownloadAllNodes.styles.scss';

type DownloadAllNodesProps = {
  className?: string;
};

const DownloadAllNodes: React.FC<DownloadAllNodesProps> = (props) => {
  const { className } = props;

  const classes = classNames('download-all-nodes', className);

  const { openDownloadModal } = useContext(FileDownloadContext);
  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);
  const { currentlyDisplayedNodes, documentRoute, baseLevelNodes } = useContext(
    DataRoomDocumentsContext,
  );
  const { shouldAllowBulkActions } = useContext(
    DataRoomSelectedDocumentsContext,
  );

  const { t } = useTranslation();

  const downloadableNodes = useMemo(
    () => currentlyDisplayedNodes?.filter(getCanDownloadNode),
    [currentlyDisplayedNodes],
  );

  const canDownloadAllNodes = useMemo(
    () => !documentRoute?.length && !!downloadableNodes?.length,
    [documentRoute?.length, downloadableNodes?.length],
  );

  if (!canDownloadAllNodes || !shouldAllowBulkActions) return null;

  return (
    <ResolvePopup
      className={classes}
      onHover
      preferUpwards
      popupContent={
        <p className="download-all-nodes__popup">{t('downloadAllFiles')}</p>
      }
    >
      <Button
        icon={DownloadIcon}
        onClick={() => openDownloadModal(dataRoomId, [], baseLevelNodes)}
      >
        {t('downloadAll')}
      </Button>
    </ResolvePopup>
  );
};

export default DownloadAllNodes;
